import { render, staticRenderFns } from "./Travincal.vue?vue&type=template&id=f9264bf6"
import script from "./Travincal.vue?vue&type=script&lang=js"
export * from "./Travincal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports